module.exports = __webpack_public_path__ + "img/recoverybg.5481e2a6.png";